// extracted by mini-css-extract-plugin
export default {"chartBarWrapper":"newBarCharts_chartBarWrapper__ibbIx"};